import { cn } from "@repo/shared/utils";
import { Label } from "./Label";
import { CheckboxInput } from "./CheckboxInput";

export type CheckboxGroupInputProps = {
  value: string[];
  onValueChange: (value: string[]) => void;
  disabled?: boolean;
  label?: string;
  options: { key: string; label: string }[];
  labelStyle?: string;
  containerStyle?: string;
  orientation?: "horizontal" | "vertical";
  wrap?: boolean;
  placeholder?: string;
};

export const CheckboxGroupInput = ({
  value,
  onValueChange,
  disabled,
  label,
  options,
  labelStyle,
  containerStyle,
  orientation,
  wrap,
}: CheckboxGroupInputProps) => {
  const handleCheck = (item: string) => {
    const tmpValue = value;
    const index = value.indexOf(item);
    if (index >= 0) {
      tmpValue.splice(index, 1);
    } else {
      tmpValue.push(item);
    }
    console.log(tmpValue);
    onValueChange(tmpValue);
  };
  return (
    <div
      className={cn(
        "flex gap-y-1 mt-1.5",
        orientation === "horizontal"
          ? "flex-row items-center gap-x-3"
          : "flex-col",
        containerStyle
      )}
    >
      {label && <Label className={labelStyle} label={label} />}

      <div
        className={cn("flex gap-x-4", wrap ? "flex-row flex-wrap" : "flex-col")}
      >
        {options.map((option, index) => (
          <CheckboxInput
            disabled={disabled}
            key={index}
            label={option.label}
            checked={value.includes(option.key)}
            onCheckedChange={() => handleCheck(option.key)}
            orientation="horizontal"
          />
        ))}
      </div>
      <div></div>
    </div>
  );
};
